export const STAR_ICON = "https://in.bmscdn.com/moviemode/tvod/star-icon.png";
